import React from 'react';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-gray-200 bg-white px-4 py-4 text-center sm:px-6 lg:px-8">
      <p className="text-xs text-gray-500">
        Copyright {currentYear} © All right reserved
      </p>
    </footer>
  );
}

export default Footer;